import { IGridElement } from '../../types';

export const getValidationData = (row: IGridElement[]) =>
  row.map((cell) => cell.value).join('');



// WEBPACK FOOTER //
// ./src/views/LinkCreateBulk/components/services/getValidationData.ts